import { Id } from "@/fx/Id";
import { SYS } from "../../system";
import { updateCommandDescriptor } from "../_common/command-descriptors";
import { testDefaults } from "./_common/test-defaults";

export type ImpersonateUser = {
  impersonating?: SYS.UserId;
};
export type RawImpersonateUser = Omit<ImpersonateUser, "id" | "impersonating"> & {
  impersonating?: bigint;
};
export const toRawImpersonateUser = (_: ImpersonateUser): RawImpersonateUser => ({
  ..._,
  impersonating:  _.impersonating?.asInt,
});
export const fromRawImpersonateUser = (_: RawImpersonateUser): ImpersonateUser => ({
  ..._,
  impersonating: _.impersonating ? Id.from(_.impersonating) as SYS.UserId : undefined,
});
export const ImpersonateUser = (() => {
  const descriptor = updateCommandDescriptor({
    commandName:    "ImpersonateUser",
    commandToRaw:   toRawImpersonateUser,
    commandFromRaw: fromRawImpersonateUser,
  });
  const generated = {};
  const tests     = {};

  return { descriptor, generated, testDefaults, tests };
})();
